import { render } from "./TilmeldProfilKvittering.vue?vue&type=template&id=746280c8"
import script from "./TilmeldProfilKvittering.vue?vue&type=script&lang=js"
export * from "./TilmeldProfilKvittering.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__